import axios from 'axios';
import { useEffect, useState } from 'react';
import Box from 'elements/Box';
import {
  CircularProgress,
  Pagination,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow
} from '@mui/material';
import { ProjectConfig } from 'Global';

const FiestasList = () => {
  const [loading, setLoading] = useState(false);
  const [list, setList] = useState<any[]>([]);
  const [totalPages, setTotalPages] = useState(0);

  const currentPage = parseInt(localStorage.getItem('page') || '1');
  const [page, setPage] = useState(currentPage);

  useEffect(() => {
    setLoading(false);

    axios.get(ProjectConfig.api_url, {
      params: {
        request: 'fiestas_list',
        page: page,
      }
    })
      .then((response) => {
        setList(response.data.list || []);
        setTotalPages(response.data.total_pages || 0);
        setLoading(true);
      })
      .catch((err) => {
        console.log(err?.data || err);
        setLoading(true);
      });

    localStorage.setItem('page', page.toString());
  }, [page]);

  return (
    <div id='ProductList'>
      <div id="task_list_container" className="flex_container">
        <Box id='user_list' title="COMUNES" subtitle="Catálogo litúrgico">
          {!loading && <div id='loader'><CircularProgress /></div>}

          <TableContainer>
            <Table stickyHeader aria-label="Comunes litúrgicos">
              <TableHead>
                <TableRow>
                  <TableCell>Común</TableCell>
                  <TableCell>Familia</TableCell>
                  <TableCell>Contenido</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {list.map((item) => (
                  <TableRow
                    key={item.fiesta_id}
                    hover
                    onClick={() => {
                      window.location.href = `/admin/fiestas/edit/${item.fiesta_id}`;
                    }}
                    style={{ cursor: 'pointer' }}
                  >
                    <TableCell>{item.titulo}</TableCell>
                    <TableCell>
                      {item.common_meta?.family_title || '—'}
                      {item.common_meta?.variant
                        ? ` · ${item.common_meta.variant}`
                        : ''}
                    </TableCell>
                    <TableCell>
                      {Number(item.structured_rows || 0) > 0
                        ? `${item.structured_rows} registros estructurados · ${item.structured_languages} idiomas · ${item.structured_scopes}/3 ámbitos`
                        : `${item.content_sections_filled}/${item.content_sections_total} secciones heredadas con contenido`}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>

          {totalPages > 1 && (
            <Pagination
              count={totalPages}
              page={page}
              onChange={(_, value) => setPage(value)}
              color="primary"
              style={{ marginTop: '20px', alignSelf: 'center' }}
            />
          )}
        </Box>
      </div>
    </div>
  );
};

export default FiestasList;
